@if (storeId) {
  <div class="space-y-6">
    <form (ngSubmit)="onSubmit()" class="space-y-6">
      <div class="space-y-2">
        <div class="text-xs font-semibold uppercase tracking-[0.3em] text-base-content/60">Operation</div>
        <ui-button-group gap="sm" [fullWidthMobile]="true">
          <ui-button
            [variant]="operation === StockOperation.Add ? 'success' : 'ghost'"
            size="sm"
            (clicked)="setOperation(StockOperation.Add)">
            Add
          </ui-button>
          <ui-button
            [variant]="operation === StockOperation.Remove ? 'danger' : 'ghost'"
            size="sm"
            (clicked)="setOperation(StockOperation.Remove)">
            Remove
          </ui-button>
        </ui-button-group>
      </div>

      @if (operation === StockOperation.Add) {
        <div class="space-y-2">
          <label class="text-sm font-semibold text-base-content" for="expiry-date">Expiry</label>
          <div>
            <ui-datepicker
              class="w-full"
              [value]="expiryDate"
              placeholder="yyyy-mm-dd"
              triggerStyle="input"
              (dateSelected)="onDateSelected()">
            </ui-datepicker>
          </div>
        </div>
      }

      <div class="space-y-2">
        <label class="text-sm font-semibold text-base-content" for="product-code">EAN</label>
        <div class="flex flex-wrap items-center gap-2">
          <input
            #code
            type="text"
            class="input input-bordered flex-1 min-w-0"
            placeholder="Barcode"
            id="product-code"
            name="product-code"
            [(ngModel)]="input">
          @if (inputMode === eStockInputMode.Form) {
            <ui-button variant="ghost" size="sm" class="md:hidden" type="button" (clicked)="openScanner()">
              <fa-icon [icon]="faScan" class="mr-1"></fa-icon>
              Scanner
            </ui-button>
          }
          @if (inputMode === eStockInputMode.Scan) {
            <ui-button variant="danger" [outline]="true" size="sm" class="md:hidden" type="button"
              (clicked)="changeInputMode(eStockInputMode.Form)">
              Close
            </ui-button>
          }
        </div>
      </div>

      <button type="submit" class="sr-only" aria-hidden="true">Submit</button>
    </form>

    <ui-modal
      #scannerModal
      title="Barcode Scanner"
      size="full"
      [showCloseButton]="true"
      [closeOnBackdrop]="true"
      (modalClosed)="onScannerClosed()">

      <app-scanner
        #scanner
        [op]="operation"
        [sound]="true"
        (scannerReady)="onScannerReadyChanged($event)"
        (codeAccepted)="onScannerCodeAccepted($event)">
      </app-scanner>

      <div modal-footer class="flex justify-end gap-2">
        <ui-button variant="ghost" type="button" (clicked)="scannerModal.close()">Close</ui-button>
      </div>
    </ui-modal>

    @if (inputMode === eStockInputMode.Scan) {
      <div class="scanner-wrapper mt-4" [class.fullscreen]="isMobile">
        <app-scanner
          [op]="operation"
          (scannerReady)="onScannerReadyChanged($event)"
          [sound]="true"
          (productScanned)="onProductScanned($event)">
        </app-scanner>
        @if (scannerReady) {
          <div class="flex justify-around mt-3">
            <strong>Initializing Scanner...</strong>
            <span class="loading loading-spinner loading-md"></span>
          </div>
        }
      </div>
    }
  </div>
} @else {
  <div class="rounded-2xl border border-error/40 bg-error/10 px-4 py-3 text-sm font-medium text-error">
    Please select a valid Store in the Context Selection
  </div>
}
